const CalendarState = {
  calendarEventsByDay: {},
  teeupEventsByDay: {
    noExactDate: [],
  },
  calSyncInProgress: false,
  calendarEvents: {},
  teeupEvents: {},
  calendarDays: [],
  avaliableCalendars: [],
  calendarPermissions: null,
  suggestWeek: [],
  isBeforeCalendarDate: false,
}

export default CalendarState
